import WeatherMapSegmentedControl from '../../../../components/WeatherMapSegmentedControl/WeatherMapSegmentedControl';
import { HURRICANES_DATASET_OPTIONS, HURRICANES_DATASETS } from '../../config/hurricanes.config';
import HurricaneDataStatus from '../HurricaneDataStatus/HurricaneDataStatus';
import StormDetailsPanel from '../StormDetailsPanel/StormDetailsPanel';
import StormSelector from '../StormSelector/StormSelector';
import StormReplayPanel from './components/StormReplayPanel/StormReplayPanel';

const HurricaneInformationPanel = ({
  stormGroups = [],
  selectedStormKey,
  selectedStorm,
  activeRecord,
  dataset,
  hasLiveStorms,
  liveError,
  historicalError,
  isRefreshing,
  isDatasetToggleDisabled,
  replay,
  markerMode,
  onSelectStorm,
  onDatasetChange,
  onMarkerModeChange,
}) => (
  <section
    aria-label="Hurricane and tropical storm information"
    className="hurricanes-information-panel d-flex h-100 min-h-0 flex-column gap-3 overflow-hidden p-2"
  >
    <div className="hurricanes-information-controls flex-shrink-0">
      <StormSelector
        stormGroups={stormGroups}
        selectedStormKey={selectedStormKey}
        onSelectStorm={onSelectStorm}
        includeAllOption={dataset === HURRICANES_DATASETS.live}
      />

      <fieldset className="hurricanes-dataset-control m-0 min-w-0 border-0 p-0">
        <legend className="mb-1 fs-6 fw-medium">Dataset</legend>
        <WeatherMapSegmentedControl
          ariaLabel="Storm dataset"
          options={HURRICANES_DATASET_OPTIONS}
          value={dataset}
          onChange={(nextDataset) =>
            onDatasetChange(nextDataset === HURRICANES_DATASETS.historical)
          }
          disabled={isDatasetToggleDisabled}
          buttonClassName="px-3 py-1"
        />
      </fieldset>
    </div>

    {(!hasLiveStorms || liveError || historicalError || isRefreshing) && (
      <div className="hurricanes-status-row d-flex flex-wrap align-items-center gap-2">
        {!hasLiveStorms && !liveError && (
          <span className="hurricanes-data-status small" role="status">
            No live storms at this time.
          </span>
        )}
        <HurricaneDataStatus
          liveError={liveError}
          historicalError={historicalError}
          isRefreshing={isRefreshing}
        />
      </div>
    )}

    <div className="hurricanes-information-content d-flex min-h-0 flex-grow-1 flex-column gap-3 overflow-auto">
      <StormDetailsPanel
        storm={selectedStorm}
        stormGroups={stormGroups}
        activeRecord={activeRecord}
        onSelectStorm={onSelectStorm}
      />
      <StormReplayPanel
        storm={selectedStorm}
        replay={replay}
        markerMode={markerMode}
        onMarkerModeChange={onMarkerModeChange}
      />
    </div>
  </section>
);

export default HurricaneInformationPanel;
